import { Input } from '@/components/ui/input';

/**
 * Campo de input de data com formatação automática DD/MM/AAAA
 * As barras são inseridas automaticamente conforme o usuário digita
 */
export default function DateInput({ 
  value, 
  onChange, 
  placeholder = "DD/MM/AAAA",
  className = "",
  ...props 
}) {
  const handleChange = (e) => {
    // Remover tudo que não é número
    let numbers = e.target.value.replace(/\D/g, '');
    
    // Limitar a 8 dígitos
    if (numbers.length > 8) numbers = numbers.slice(0, 8);
    
    // Formatar com barras
    let formatted = '';
    for (let i = 0; i < numbers.length; i++) {
      if (i === 2 || i === 4) formatted += '/';
      formatted += numbers[i];
    }
    
    onChange(formatted);
  };

  const handleKeyDown = (e) => {
    // Permitir apenas números, backspace, delete, tab, setas
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Input
      type="text"
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      maxLength={10}
      className={className}
      {...props}
    />
  );
}
